import React from 'react'

export default function CardCounter({ icon, label, counter,width,height }) {
  return (
    <div className="flex flex-col items-center space-y-10 text-center mainWrapper">
      <div className="imageWrapper">
        <img src={icon} alt={label} width={width} height={height} />
      </div>
      <span className="block text-3xl cardCounterLabel text-primary">{counter}</span>
      <p className="w-[200px] mt-10 text-base font-semibold text-cardText group-hover:hover:text-primary">
        {label}
      </p>
    </div>
  );
}
